<template>
  <div @dragover.prevent @drop.prevent>
    <router-view></router-view>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({ name: 'TheHexaplaInstitute' })
</script>
<style lang="scss">
@import '@/scss/app';
</style>
